<ngx-one-column-layout *ngIf="isLoggedIn">
    <nb-menu [items]="menu"></nb-menu>
    <router-outlet></router-outlet>
</ngx-one-column-layout>

<router-outlet *ngIf="!isLoggedIn"></router-outlet>